import type { FC, PropsWithChildren, ReactNode } from 'react';

import { AffineOtherPageLayout } from '../affine-other-page-layout';
import { AuthBackgroundArts } from './auth-background-arts';
import { AuthContainer } from './auth-container';
import { AuthContent } from './auth-content';
import { AuthHeader } from './auth-header';
import { FeatureIllustration } from './feature-illustration';
import {
  authJourneyAside,
  authPageContainer,
  brandAuthCardShell,
  brandAuthContent,
  brandAuthSubtitle,
  brandAuthTitle,
  hideInSmallScreen,
  illustration,
} from './share.css';
import { SignInPageContainer } from './sign-in-page-container';

type AuthPageVisual = 'feature' | 'brand' | 'none';

export const AuthPageContainer: FC<
  PropsWithChildren<{
    title?: ReactNode;
    subtitle?: ReactNode;
    visual?: AuthPageVisual;
    journey?: ReactNode;
  }>
> = ({ children, title, subtitle, visual = 'feature', journey }) => {
  if (visual === 'brand') {
    return (
      <AffineOtherPageLayout
        showNavigation={false}
        showCollaborationCursors={false}
      >
        <AuthBackgroundArts />
        <SignInPageContainer>
          <div className={brandAuthCardShell}>
            <AuthContainer>
              {typeof title === 'string' ? (
                <AuthHeader
                  className={brandAuthTitle}
                  title={title}
                  subTitle={typeof subtitle === 'string' ? subtitle : undefined}
                />
              ) : title ? (
                <div className={brandAuthTitle}>{title}</div>
              ) : null}
              {subtitle && typeof subtitle !== 'string' ? (
                <div className={brandAuthSubtitle}>{subtitle}</div>
              ) : null}
              <AuthContent className={brandAuthContent}>
                {children}
                {journey}
              </AuthContent>
            </AuthContainer>
          </div>
        </SignInPageContainer>
      </AffineOtherPageLayout>
    );
  }

  const visualNode =
    visual === 'feature' ? (
      <FeatureIllustration className={illustration} />
    ) : null;

  return (
    <AffineOtherPageLayout showCollaborationCursors={false}>
      <div className={authPageContainer}>
        <div className="wrapper">
          <div className="content">
            {title ? <div className="title">{title}</div> : null}
            {subtitle ? <div className="subtitle">{subtitle}</div> : null}
            {children}
            {journey ? <div className={authJourneyAside}>{journey}</div> : null}
          </div>
          {visualNode ? (
            <div className={hideInSmallScreen}>{visualNode}</div>
          ) : null}
        </div>
      </div>
    </AffineOtherPageLayout>
  );
};
